import { delCookie, localRead, goOut, session } from '@/libs/util'
import store from '@/store'
import { sceneApi } from '@/configs/index'

export const baseAjaxParam = (vm) => {
  let data = {}
  data.opId = +session.get('userId')
  data.opNum = session.get('userNum')
  data.opName = session.get('userName')
  data.loginAt = localRead('loginAt')
  data.shopId = session.get('shopId')
  data.shopName = store.state.shopName
  data.shopNum = store.state.shopNum
  data.brandId = store.state.brandId
  data.branchId = store.state.brandId
  data.brandName = store.state.brandName
  data.cityId = store.state.cityId
  data.cityName = store.state.cityName
  data.agentId = store.state.agentId
  data.agentName = store.state.agentName
  data.token = localRead('token')
  if (setValidateBoolean(data.brandId)) {
    data.brandId = session.get('brandId')
    data.branchId = session.get('branchId')
  }
  if (setValidateBoolean(data.cityId)) {
    data.cityId = session.get('cityId')
  }
  if (setValidateBoolean(data.agentId)) {
    data.agentId = session.get('agentId')
  }

  // data.partner_id = store.state.partnerId
  // // 如果是子账号添加参数
  // if (store.state.roleId !== '0') {
  //   data.subRegionIds = store.state.subRegionIds
  //   data.masterPartnerId = store.state.masterPartnerId
  // }
  // data.partnerId = store.state.partnerId
  // data.createdById = store.state.partnerId
  // data.createdBy = store.state.partnerName
  return data
}

export const baseAjaxErr = (vm, res) => {
  const code = res.data.code
  const errMsg = res.data.msg
  switch (code) {
    case -1:
      vm.$toast('系统正忙，请稍后再试！')
      break
    case -2:
      vm.$toast('当前正在有人查询大量数据，服务器资源占用已满，请您稍后再来查询')
      break
    case 40001:
      delCookie('ycmanager_access_token')
      delCookie('ycmanager_partner_id')
      delCookie('ycmanager_user_phone')
      vm.$toast('接口权限错误')
      break
    case 110:
      // vm.$toast.error({ content: '登录过期，请重新登录！', closable: true, duration: 10 })
      goOut(vm)
      break
    case 41001:
      vm.$toast('提供参数错误，请检查操作是否合法')
      break
    case 41007:
      vm.$toast('随机码超时，请刷新页面！')
      tologin(vm)
      break
    case 61001:
      vm.$toast(errMsg)
      break
    case 200021:
      vm.$toast('该用户无管理权限，请联系管理员')
      tologin(vm)
      break
    case 200008:
      vm.$toast('员工信息不存在！')
      tologin(vm)
      break
    case 200020:
      vm.$toast('该用户无操作权限，请联系管理员！')
      tologin(vm)
      break
    case 200022:
      vm.$toast('用户与角色不匹配')
      tologin(vm)
      break
    case 200023:
      vm.$toast('员工信息不存在！')
      tologin(vm)
      break
    case 200024:
      vm.$toast('该员工为未入职状态，无操作权限！')
      tologin(vm)
      break
    case 200027:
      vm.$toast('该用户已被禁用,请联系管理员！')
      tologin(vm)
      break
    // case 400002:
    //   // 用户未找到
    //   break
    case 100001:
      vm.$toast('参数错误')
      break
    case 200001:
      vm.$toast('参数错误')
      break
    case 200002:
      vm.$toast('门店不存在')
      break
    case 100002:
      vm.$toast('验证码错误')
      break
    case 610001:
      vm.$toast('卡类别不存在')
      break
    case 610002:
      vm.$toast('当前方案应用门店与其他方案应用门店重复')
      break
    case 610003:
      vm.$toast('方案不存在')
      break
    case 610004:
      vm.$toast('疗程卡类别已停止销售')
      break
    case 620001:
      vm.$toast('门店应用方案不存在')
      break
    case 620002:
      vm.$toast('当前方案应用门店与其他方案应用门店重复')
      break
    case 620003:
      vm.$toast('方案不存在')
      break
    case 621001:
      vm.$toast('卡方案中的卡类别不存在')
      break
    case 621002:
      vm.$toast('卡方案的升级信息不存在')
      break
    case 621003:
      vm.$toast('卡方案的账户信息不存在')
      break
    case 621004:
      vm.$toast('卡方案的项目信息不存在')
      break
    case 621101:
      vm.$toast('不允许充值')
      break
    case 621102:
      vm.$toast('不符合升级条件, 不允许升级')
      break
    case 621103:
      vm.$toast('会员卡已升级, 不允许撤销')
      break
    case 622001:
      vm.$toast('项目方案不存在')
      break
    case 622002:
      vm.$toast('项目方案中不存在此项目')
      break
    case 623001:
      vm.$toast('产品方案不存在')
      break
    case 623002:
      vm.$toast('产品方案中不存在此产品')
      break
    case 800001:
      vm.$toast('用户不存在')
      break
    case 810001:
      vm.$toast('没有此会员卡信息，请检查后重新输入！')
      break
    case 810002:
      vm.$toast('会员卡状态异常，请检查后重新输入！')
      break
    case 810003:
      vm.$toast('会员卡密码错误，请检查后重新输入！')
      break
    case 810101:
      vm.$toast('会员卡备注不存在')
      break
    case 811001:
      vm.$toast('会员卡账户不存在')
      break
    case 811002:
      vm.$toast('会员卡账户状态异常')
      break
    case 811003:
      vm.$toast('会员卡账户余额不足')
      break
    case 811004:
      vm.$toast('会员卡账户疗程余额不足')
      break
    case 811005:
      vm.$toast('会员卡账户无欠款')
      break
    case 850002:
      vm.$toast('无会员卡可修改')
      break
    case 850003:
      vm.$toast('会员卡已存在')
      break
    case 850004:
      vm.$toast('会员卡异动单据已撤销')
      break
    case 850005:
      vm.$toast('会员卡异动单据日志不存在')
      break
    case 850006:
      vm.$toast('会员卡消费单据已撤销')
      break
    case 850007:
      vm.$toast('会员卡消费单据日志不存在')
      break
    case 850101:
      vm.$toast('已存在此交易订单号的消费日志')
      break
    case 850102:
      vm.$toast('会员卡账户的交易日志不存在')
      break
    case 850103:
      // vm.$toast.error({ content: '会员卡账户的交易日志已存在', closable: true, duration: 10 })
      vm.$toast('该消费单号已存在，请重新输入')
      break
    case 850104:
      vm.$toast('会员卡账户的交易明细不存在')
      break
    case 850105:
      vm.$toast('会员卡账户的交易流水不存在')
      break
    case 850201:
      vm.$toast('购买疗程单据已撤销')
      break
    case 850202:
      vm.$toast('购买疗程交易日志不存在')
      break
    case 850203:
      vm.$toast('退疗程交易日志已撤销')
      break
    case 850204:
      vm.$toast('退疗程交易日志不存在')
      break
    case 850205:
      vm.$toast('会员卡账户疗程流水不存在')
      break
    case 850206:
      vm.$toast('会员卡账户疗程交易明细不存在')
      break
    case 850207:
      vm.$toast('会员卡账户疗程不存在')
      break
    case 850208:
      vm.$toast('会员卡账户疗程状态异常')
      break
    case 850301:
      vm.$toast('会员卡日志不存在')
      break
    case 850302:
      vm.$toast('会员卡日志已存在')
      break
    case 850303:
      vm.$toast('不允许合并会员卡')
      break
    case 850304:
      vm.$toast('不允许撤销')
      break
    case 850305:
      vm.$toast('操作已撤销')
      break
    case 850306:
      vm.$toast('不允许变更卡种')
      break
    case 850307:
      vm.$toast('不允许撤销, 因为会员卡存在异动')
      break
    case 850308:
      vm.$toast('有欠款的会员卡不允许退费并降级')
      break
    case 850309:
      vm.$toast('该单据已开过赠卡，请删除赠卡单据后再操作')
      break
    default:
      vm.$toast(errMsg)
  }
}

export const tologin = (vm) => {
  setTimeout(() => {
    session.clearAll()
    if (vm.$route.name !== 'login') {
      if (sceneApi === 'https://j.mubei.cn/') {
        window.location.href = 'https://j.mubei.cn/login'
      }
    }
  }, 3000)
}

export const getStrLength = (str) => {
  let realLength = 0
  let len = str.length
  let charCode = -1
  for (var i = 0; i < len; i++) {
    charCode = str.charCodeAt(i)
    if (charCode >= 0 && charCode <= 128)realLength += 1
    else realLength += 2
  }
  return realLength
}

export const addErrorLog = (errorInfo) => {
  let info = {
    type: 'ajax',
    code: errorInfo.status,
    mes: errorInfo.statusText,
    url: errorInfo.url
  }
  if (errorInfo) store.dispatch('addErrorLog', info)
}
/* get请求参数拼接 */
export const serialize = (obj) => {
  return Object.keys(obj).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`).join('&')
}
